import apiClient from "@services/api/apiClient.jsx";

const photoFrameApi = {
  // 포토 프레임 목록 조회
  getPhotoFrames: async (params = {}) => {
    try {
      const response = await apiClient.get('/photo-frames', { params });
      return response.data;
    } catch (error) {
      console.error('포토 프레임 목록 조회 실패:', error);
      throw error;
    }
  },

  // 포토 프레임 상세 조회
  getPhotoFrame: async (id) => {
    try {
      const response = await apiClient.get(`/photo-frames/${id}`);
      return response.data;
    } catch (error) {
      console.error('포토 프레임 상세 조회 실패:', error);
      throw error;
    }
  },

  // 포토 프레임 생성 (JSON 요청)
  createPhotoFrame: async (data) => {
    try {
      const response = await apiClient.post('/photo-frames', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('포토 프레임 생성 실패:', error);
      throw error;
    }
  },

  // 포토 프레임 수정 (JSON 요청)
  updatePhotoFrame: async (id, data) => {
    try {
      const response = await apiClient.put(`/photo-frames/${id}`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('포토 프레임 수정 실패:', error);
      throw error;
    }
  },

  // 포토 프레임 삭제
  deletePhotoFrame: async (id) => {
    try {
      const response = await apiClient.delete(`/photo-frames/${id}`);
      return response.data;
    } catch (error) {
      console.error('포토 프레임 삭제 실패:', error);
      throw error;
    }
  },

  // 포토 프레임 일괄 삭제 (bulk 엔드포인트 사용)
  deletePhotoFrames: async (ids) => {
    try {
      const response = await apiClient.delete('/photo-frames/bulk', {
        data: ids
      });
      return response.data;
    } catch (error) {
      console.error('포토 프레임 일괄 삭제 실패:', error);
      throw error;
    }
  },

  // 프레임명 중복 확인
  checkFrameNameDuplicate: async (frameName, excludeId = null) => {
    try {
      const params = { frameName };
      if (excludeId) {
        params.excludeId = excludeId;
      }
      const response = await apiClient.get('/photo-frames/check-duplicate', { params });
      return response.data;
    } catch (error) {
      console.error('프레임명 중복 확인 실패:', error);
      throw error;
    }
  },

  // 배포된 프레임 목록 조회
  getActiveFrames: async (page = 0, size = 10) => {
    try {
      const response = await apiClient.get('/photo-frames/active', { 
        params: { page, size } 
      });
      return response.data;
    } catch (error) {
      console.error('배포된 프레임 목록 조회 실패:', error);
      throw error;
    }
  },

  // 모든 포토 프레임 목록 조회
  getAllPhotoFrames: async () => {
    try {
      const response = await apiClient.get('/photo-frames/all');
      return response.data;
    } catch (error) {
      console.error('모든 포토 프레임 목록 조회 실패:', error);
      throw error;
    }
  },

  // 배포 상태 토글
  toggleDeployStatus: async (id, updatedBy) => {
    try {
      const response = await apiClient.patch(`/photo-frames/${id}/toggle-deploy`, null, {
        params: { updatedBy }
      });
      return response.data;
    } catch (error) {
      console.error('포토 프레임 배포 상태 변경 실패:', error);
      throw error;
    }
  },

  // 지점별 포토 프레임 조회
  getPhotoFramesByBranch: async (branchId) => {
    try {
      const response = await apiClient.get(`/photo-frames/by-branch/${branchId}`);
      return response.data;
    } catch (error) {
      console.error('지점별 포토 프레임 조회 실패:', error);
      throw error;
    }
  },

  // FormData 생성 헬퍼 (사용하지 않음)
  createFormData: (data) => {
    // JSON 방식으로 변경했으므로 FormData 대신 일반 객체 반환
    return data;
  }
};

export default photoFrameApi;
